import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ProjectState_AwaitingFunding_getInstance2uhrgbgvubwqq as ProjectState_AwaitingFunding_getInstance } from '../../../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import {
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { newChangesAlloweduwl70y4cy8dt as newChangesAllowed } from '../../../../../../../../crowpay-shared/com/crowpay/statePermissions.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { AddWorkItemCreditDialog1hq298k1vgsaa as AddWorkItemCreditDialog } from '../../../../dialogs/CreditDialogs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import {
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import { get_projectgtrfvpc0zfzj as get_project } from '../../../../../../../../crowpay-shared/com/crowpay/ChangeRequestFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { get_mainPageNavigator29w1pddlp5wea as get_mainPageNavigator } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Navigator.mjs';
import { ChangeOrderForm23hgjlgmtvjevd as ChangeOrderForm2 } from '../changeOrders/ChangeOrderForm2.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function lineItemAddCreditButton(_this__u8e3s4, item, project) {
  var tmp = _this__u8e3s4.kbb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => {
    var item_0 = $this$shownWhen.daj(item);
    var project_0 = $this$shownWhen.daj(project);
    return project_0.u7b_1.d4(ProjectState_AwaitingFunding_getInstance()) >= 0 && item_0.y91();
  }), get_tertiaryButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, '+ Credit');
  onClick(view, VOID, VOID, lineItemAddCreditButton$slambda_0(item));
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
function lineItemAddChangeButton(data, _this__u8e3s4, item) {
  var tmp = _this__u8e3s4.kbb(shownWhen(_this__u8e3s4, VOID, ($this$shownWhen) => newChangesAllowed($this$shownWhen.daj(item).p6k_1)), get_tertiaryButton(_this__u8e3s4));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Button())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.gbb(p, view);
  specCenteredText(view, '+ Change');
  onClick(view, VOID, VOID, lineItemAddChangeButton$slambda_0(data, item, view));
  _this__u8e3s4.hbb(p, view);
  _this__u8e3s4.lbb(tmp, view);
}
function *_generator_invoke__zhh2q8($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fhw_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp$ret$0 = tmp_0;
  tmp.zgd(AddWorkItemCreditDialog(tmp$ret$0));
  return Unit_instance;
}
var lineItemAddCreditButton$slambdaClass;
function lineItemAddCreditButton$slambda() {
  if (lineItemAddCreditButton$slambdaClass === VOID) {
    class $ {
      constructor($item) {
        this.fhw_1 = $item;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    lineItemAddCreditButton$slambdaClass = $;
  }
  return lineItemAddCreditButton$slambdaClass;
}
function lineItemAddCreditButton$slambda_0($item) {
  var i = new (lineItemAddCreditButton$slambda())($item);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = $this.ghw_1.lf8();
  var tmp_1 = session.vfw().lff_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_2 = serializerOrContextual(createKType(getKClass(ChangeRequest()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_2, KSerializer()) ? tmp_2 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp$ret$5 = eq(get_project(it), $this.ghw_1.lf8());
  var tmp_3 = tmp_1.afi(tmp$ret$5, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var new_0 = new (ChangeRequest())(VOID, tmp_0, VOID, '', VOID, VOID, VOID, VOID, VOID, VOID, VOID, (tmp_3 + 1 | 0).toString());
  var tmp_4 = session.jfv_1.lft(new_0, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var tmp0_project = $this.ghw_1.lf8();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.hhw_1;
  var tmp_5 = await_0(this_1, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  var tmp1_itemId = tmp_5.e6k_1;
  var tmp2_changeRequest = new_0.o57_1;
  var tmp3_itemNumber = new_0.z57_1 + '.1';
  var change = new (PendingItemChange())(VOID, tmp0_project, tmp2_changeRequest, tmp1_itemId, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp3_itemNumber);
  var tmp_6 = session.vfv_1.lft(change, $completion);
  if (tmp_6 === get_COROUTINE_SUSPENDED())
    tmp_6 = yield tmp_6;
  get_mainPageNavigator($this.ihw_1).fbw(new (ChangeOrderForm2())($this.ghw_1.lf8(), new_0.o57_1, $this.ghw_1));
  return Unit_instance;
}
var lineItemAddChangeButton$slambdaClass;
function lineItemAddChangeButton$slambda() {
  if (lineItemAddChangeButton$slambdaClass === VOID) {
    class $ {
      constructor($data, $item, $$this$button) {
        this.ghw_1 = $data;
        this.hhw_1 = $item;
        this.ihw_1 = $$this$button;
      }
      uao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    lineItemAddChangeButton$slambdaClass = $;
  }
  return lineItemAddChangeButton$slambdaClass;
}
function lineItemAddChangeButton$slambda_0($data, $item, $$this$button) {
  var i = new (lineItemAddChangeButton$slambda())($data, $item, $$this$button);
  var l = ($completion) => i.uao($completion);
  l.$arity = 0;
  return l;
}
//region block: exports
export {
  lineItemAddChangeButton as lineItemAddChangeButton2cl2byr2d3toa,
  lineItemAddCreditButton as lineItemAddCreditButtonjm3cq3yje8r4,
};
//endregion

//# sourceMappingURL=components.mjs.map
